import gsap from 'gsap'
import { breakpoints } from 'utility/helpers'

let lastWindowHeight = 0

const el = {
  allNavigationLinks: document.querySelectorAll(
    '.navigation__link'
  ) as NodeListOf<HTMLElement>,
  allPageLinks: document.querySelectorAll('a') as NodeListOf<HTMLElement>,
  header: document.querySelector('.header'),
  mainList: document.querySelector('.navigation > .navigation__list'),
  trigger: document.querySelector('.navigation-trigger'),
  backTriggers: document.querySelectorAll(
    '.navigation-backward-trigger'
  ) as NodeListOf<HTMLElement>,
  forwardTriggers: document.querySelectorAll(
    '.navigation-forward-trigger'
  ) as NodeListOf<HTMLElement>,
}

const Navigation = {
  init: () => {
    Navigation.hideMobileNavigation()
    window.addEventListener('resize', Navigation.hideMobileNavigationOnResize)

    if (el.trigger) {
      el.trigger.addEventListener('click', Navigation.toggleMobileNavigation)
    }
    Navigation.handleMobileNavigationLevels()
  },

  handleMobileNavigationLevels: () => {
    el.forwardTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth < breakpoints.desktopLG) {
          const currentItems = Array.from(trigger.closest('.navigation__list').children)
          const activeList = trigger.parentElement.nextElementSibling
          const activeCurrentItem = trigger.parentElement.parentElement
          const activeItems = Array.from(
            trigger.parentElement.nextElementSibling.children
          )

          gsap.to(currentItems, {
            duration: 0.2,
            ease: 'power2.out',
            opacity: 0,
            overwrite: true,
            stagger: 0.05,
            y: -33,
            onComplete: () => {
              activeList.classList.add('navigation__list--active')
              activeCurrentItem.classList.add('navigation__item--active')
              trigger.classList.add('navigation__link--hidden')
              trigger.parentElement.classList.add('navigation__linkwrap--hidden')

              currentItems.forEach((item) => {
                gsap.set(item, { clearProps: 'transform,opacity', overwrite: true })
                item.classList.remove('navigation__item--hidden')
                if (!item.classList.contains('navigation__item--active'))
                  item.classList.add('navigation__item--hidden')
              })

              gsap.fromTo(
                activeItems,
                {
                  opacity: 0,
                  y: 123,
                },
                {
                  clearProps: 'transform,opacity',
                  duration: 1,
                  ease: 'power4.out',
                  opacity: 1,
                  overwrite: true,
                  stagger: 0.05,
                  y: 0,
                }
              )
            },
          })

          event.preventDefault()
        }
      })
    })

    el.backTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const currentList = trigger.closest('.navigation__list')
        const currentItem = currentList.parentElement
        const currentItems = Array.from(currentList.children)
        const currentLink = currentList.previousElementSibling
        const parentItems = Array.from(currentItem.parentElement.children)
        const currentLinkButton = currentLink.getElementsByTagName('button')[0]

        gsap.to(currentItems, {
          duration: 0.2,
          ease: 'power2.out',
          opacity: 0,
          overwrite: true,
          stagger: 0.05,
          y: -33,
          onComplete: () => {
            currentList.classList.remove('navigation__list--active')
            currentItem.classList.remove('navigation__item--active')
            currentLink.classList.remove('navigation__link--hidden')
            currentLink.classList.remove('navigation__linkwrap--hidden')
            currentLinkButton.classList.remove('navigation__link--hidden')

            parentItems.forEach((item) =>
              item.classList.remove('navigation__item--hidden')
            )

            gsap.fromTo(
              parentItems,
              {
                opacity: 0,
                y: 123,
              },
              {
                clearProps: 'transform,opacity',
                duration: 1,
                ease: 'power4.out',
                opacity: 1,
                overwrite: true,
                stagger: 0.05,
                y: 0,
              }
            )
          },
        })

        event.preventDefault()
      })
    })
  },

  hideMobileNavigation: () => {
    document.documentElement.classList.remove('h--disable-scroll')
    el.header.classList.remove('header--navigation-active')

    if (!el.mainList) return // last minute hack for en/pl versions with no navigation

    const lists = el.mainList.querySelectorAll('.navigation__list')
    const items = el.mainList.querySelectorAll('.navigation__item')
    const links = el.mainList.querySelectorAll('.navigation__link')

    lists.forEach((list) => list.classList.remove('navigation__list--active'))
    items.forEach((item) => item.classList.remove('navigation__item--active'))
    items.forEach((item) => item.classList.remove('navigation__item--hidden'))
    links.forEach((link) => link.classList.remove('navigation__link--hidden'))
  },

  hideMobileNavigationOnResize: () => {
    const currentHeight = window.innerHeight
    const verticalResize = currentHeight !== lastWindowHeight
    lastWindowHeight = currentHeight

    if (!verticalResize) Navigation.hideMobileNavigation()
  },

  showMobileNavigation: () => {
    document.documentElement.classList.add('h--disable-scroll')
    el.header.classList.add('header--navigation-active')

    // staggering navigation elements
    const listItems = document.querySelectorAll('.navigation__list--active > li')
    gsap.fromTo(
      listItems,
      {
        opacity: 0,
        y: 123,
      },
      {
        clearProps: 'transform,opacity',
        duration: 1,
        ease: 'power4.out',
        opacity: 1,
        overwrite: true,
        stagger: 0.1,
        y: 0,
        onStart: () => {
          gsap.set('.header__navigation', { overflow: 'hidden' })
        },
        onComplete: () => {
          gsap.set('.header__navigation', { clearProps: 'overflow' })
        },
      }
    )

    // // layout reset to prevent bottom buttons being jumpy because of position: fixed
    // gsap.set('.layout', { clearProps: 'all', overwrite: true })

    // // a bit hacky navigation reveal
    // gsap.fromTo(
    //   '.header, .header__navigation',
    //   {
    //     bottom: 'calc(100% - 71px)',
    //     overflow: 'hidden',
    //   },
    //   {
    //     bottom: 0,
    //     clearProps: 'all',
    //     duration: 0.25,
    //     ease: 'power3.out',
    //     transition: 'none',
    //   }
    // )
  },

  toggleMobileNavigation: () => {
    if (!el.header.classList.contains('header--navigation-active')) {
      Navigation.showMobileNavigation()
    } else {
      Navigation.hideMobileNavigation()
    }
  },

  toggleSelected: (link) => {
    if (!el.mainList) return // last minute hack for en/pl versions with no navigation

    const currentItem = el.mainList.querySelector('.navigation__item--selected')
    const selectedItem = link.closest('.navigation__item')

    if (currentItem) currentItem.classList.add('navigation__item--unselected')
    if (selectedItem) selectedItem.classList.add('navigation__item--selected')
  },
}

export default Navigation
